import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/LandHome.vue')
    },
    {
        path: '/',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy Policy',
        component: () => import(/* webpackChunkName: "terms" */ '../views/info/PrivacyPolicy.vue')
    },
    {
        path: '/terms-and-conditions',
        name: 'Terms and Conditions',
        component: () => import(/* webpackChunkName: "terms" */ '../views/info/TermsConditions.vue')
    },
    {
        path: '/map',
        name: 'Map',
        component: () => import(/* webpackChunkName: "land_index" */ '../views/land/LandIndex2')
    },
    {
        path: '/map/sector',
        name: 'Sector Map',
        component: () => import(/* webpackChunkName: "land_sector" */ '../views/map/SectorMap')
    },
    {
        path: '/map/sector/:id',
        name: 'Sector Show',
        component: () => import(/* webpackChunkName: "land_index" */ '../views/land/LandIndex2')
    },
    {
        path: '/map/purchase',
        name: 'Map Purchase',
        component: () => import(/* webpackChunkName: "land_index" */ '../views/land/LandIndex2')
    },
    {
        path: '/marketplace',
        name: 'Marketplace',
        component: () => import(/* webpackChunkName: "coming_soon" */ '../views/ComingSoon.vue')
    },
    {
        path: '/land',
        name: 'Owned Land',
        component: () => import(/* webpackChunkName: "land" */ '../views/land/LandListIndex')
    },
    {
        path: '/land/:x/:y',
        name: 'Owned Land',
        component: () => import(/* webpackChunkName: "land" */ '../views/land/LandShow')
    },
    {
        path: '/events/whitelist/confirmation',
        name: 'Whitelist Confirmation',
        component: () => import(/* webpackChunkName: "whitelist" */ '../views/Whitelist')
    },
    {
        path: '/events/whitelist/success',
        name: 'Whitelist Success',
        component: () => import(/* webpackChunkName: "whitelist" */ '../views/WhitelistSuccess')
    },
    {
        path: "*",
        redirect: "/"
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
